import { fetchWithAuth } from "../auth/authService";
import { getToken, getMemberId, getGuestId } from "../../utils/tokenHelper";

export const getAppConfigService = async () => {
  const response = await fetchWithAuth("/api/Config", {
    method: "GET",
  });
  return response;
};

export const getPlansService = async () => {
  const response = await fetchWithAuth("/api/plans/list", {
    method: "GET",
  });
  return response;
};

export const selectPlanService = async (planData) => {
  const response = await fetchWithAuth("/api/plans/select-plan", {
    method: "POST",
    body: JSON.stringify({
      memberId: planData.memberId || 0,
      planId: planData.planId,
      guestId: planData.guestId,
      paymentMethod: planData.paymentMethod || "Razorpay",
    }),
  });
  return response;
};

export const syncPaymentService = async (paymentData) => {
  const response = await fetchWithAuth("/api/plans/sync-payment", {
    method: "POST",
    body: JSON.stringify({
      subscriptionId:
        typeof paymentData.subscriptionId === "object"
          ? paymentData.subscriptionId?.subscriptionId ||
            paymentData.subscriptionId?.SubscriptionId
          : paymentData.subscriptionId,
      razorpayPaymentId: paymentData.razorpayPaymentId,
    }),
  });
  return response;
};

export const mergeGuestService = async () => {
  const guestId = getGuestId();
  const response = await fetchWithAuth("/api/plans/merge-guest", {
    method: "POST",
    body: JSON.stringify({ guestId }),
  });
  return response;
};

export const getActiveSubscriptionService = async () => {
  const memberId = getMemberId();
  const url = memberId
    ? `/api/plans/active-subscription?memberId=${memberId}`
    : "/api/plans/active-subscription";

  const response = await fetchWithAuth(url, {
    method: "GET",
  });
  return response;
};

export const comparePlansService = async (planIds) => {
  const ids = Array.isArray(planIds) ? planIds.join(",") : planIds;
  const response = await fetchWithAuth(
    `/api/plans/compare?planIds=${encodeURIComponent(ids)}`,
    {
      method: "GET",
    },
  );
  return response;
};

export const downloadInvoiceService = async (subscriptionId) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL || "http://localhost:5000";
  const token = getToken();
  const appKey = import.meta.env.VITE_APP_KEY || "";

  const response = await fetch(
    `${baseUrl}/api/plans/download-invoice/${subscriptionId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        appkey: appKey,
      },
      credentials: "include",
    },
  );

  if (!response.ok) throw new Error("Failed to download invoice");
  return await response.blob();
};
